import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Calendar, BookOpen, Phone } from 'lucide-react';

const LINKS = [
  { to: '/', icon: Home, label: 'Back to Home' },
  { to: '/#services', icon: Calendar, label: 'Our Treatments' },
  { to: '/blog', icon: BookOpen, label: 'Wellness Blog' },
  { to: '/#contact', icon: Phone, label: 'Contact Us' },
];

const NotFoundPage = () => (
  <div className="min-h-screen bg-luxury-green-900 flex items-center justify-center px-6" data-testid="not-found-page">
    <div className="text-center max-w-md">
      <p className="font-display text-7xl text-luxury-gold mb-4">404</p>
      <h1 className="font-display text-2xl sm:text-3xl text-alabaster-100 mb-3">This page has drifted off to relax</h1>
      <p className="text-alabaster-300 font-light text-sm mb-10">
        The page you're looking for doesn't exist or may have moved. Let's get you back to somewhere soothing.
      </p>
      <div className="grid grid-cols-2 gap-3">
        {LINKS.map((l) => (
          <Link
            key={l.label}
            to={l.to}
            className="flex items-center justify-center gap-2 bg-luxury-green-800 border border-luxury-gold/30 hover:border-luxury-gold/70 text-alabaster-100 rounded-full px-4 py-3 text-xs uppercase tracking-wider font-medium transition-colors"
            data-testid={`notfound-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <l.icon size={14} className="text-luxury-gold" />
            {l.label}
          </Link>
        ))}
      </div>
    </div>
  </div>
);

export default NotFoundPage;
